var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form",
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.$emit("submitForm")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "grid" },
        _vm._l(_vm.formData.regions, function(group) {
          return _c(
            "div",
            { staticClass: "grid__row" },
            [
              group.label
                ? _c("p", { staticClass: "headline-medium black mg mg--b-2" }, [
                    _vm._v(_vm._s(group.label))
                  ])
                : _vm._e(),
              _vm._t("inputForms", function() {
                return [
                  _vm._l(group.inputs, function(input) {
                    return [
                      input.type === "text"
                        ? _c("ma-input-text", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              type: "text",
                              name: input.name,
                              col: input.col,
                              icon: input.icon,
                              literal: input.literal,
                              value: input.selectedValue,
                              disabled: input.disabled,
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      input.type === "counter"
                        ? _c("ma-counter", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              value: input.selectedValue,
                              literal: input.literal,
                              name: input.name,
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              col: input.col,
                              validators: input.validators
                            },
                            on: {
                              newValue: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      input.type === "textNumbers"
                        ? _c("ma-input-text-numbers", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              type: "text",
                              name: input.name,
                              col: input.col,
                              icon: input.icon,
                              literal: input.literal,
                              value: input.selectedValue,
                              disabled: input.disabled,
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              "!change": function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEventTextNumber.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray, ["textNumbers"])
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                if ($event.target !== $event.currentTarget) {
                                  return null
                                }
                                return _vm.handleEventTextNumber.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray, ["textNumbers"])
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      input.type === "textNumbers" &&
                      input.name === "DAMAGE_SURFACE"
                        ? _c("ma-input-text-area", {
                            attrs: {
                              type: "text",
                              col: input.col,
                              icon: input.icon,
                              valueTextNumber: input.selectedValue
                            }
                          })
                        : input.type === "hidden"
                        ? _c("ma-input-text", {
                            attrs: {
                              type: "text",
                              hidden: true,
                              name: input.name,
                              col: input.col,
                              icon: input.icon,
                              literal: input.literal,
                              agentLiteral: input.agent_literal,
                              value: input.selectedValue,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : input.type === "select" &&
                          (_vm.agentView === false ||
                            input.options.length > 10 ||
                            input.options.length === 1)
                        ? _c("ma-input-select", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              type: "select",
                              name: input.name,
                              col: input.col,
                              icon: input.icon,
                              literal: input.literal,
                              options: input.options,
                              value: input.selectedValue,
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : input.type === "select" && _vm.agentView === true
                        ? _c("ma-input-btn", {
                            attrs: {
                              type: "radio",
                              name: input.name,
                              col: input.col,
                              icon: input.icon,
                              literal: input.literal,
                              agentLiteral: input.agent_literal,
                              options: input.options,
                              value: input.selectedValue,
                              showTooltipBtn: input.literal_aid.length > 0,
                              textTooltipBtn:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators,
                              showNumberSelector: _vm.showNumberSelector(input)
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              },
                              piece: _vm.onPieceSelected
                            }
                          })
                        : input.type === "radio" && _vm.agentView === false
                        ? _c("ma-input-radio", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              type: "radio",
                              name: input.name,
                              col: input.col,
                              icon: input.icon,
                              literal: input.literal,
                              options: input.options,
                              value: input.selectedValue,
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : input.type === "radio" && _vm.agentView === true
                        ? _c("ma-input-btn", {
                            attrs: {
                              type: "radio",
                              name: input.name,
                              col: input.col,
                              icon: input.icon,
                              literal: input.literal,
                              options: input.options,
                              value: input.selectedValue,
                              showTooltipBtn: input.literal_aid.length > 0,
                              textTooltipBtn:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : input.type === "checkbox" && _vm.agentView === false
                        ? _c("ma-input-checkbox", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              type: "checkbox",
                              name: input.name,
                              col: input.col,
                              literal: input.literal,
                              options: input.options,
                              value: input.selectedValue,
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : input.type === "checkbox" && _vm.agentView === true
                        ? _c("ma-input-btn", {
                            attrs: {
                              type: "checkbox",
                              name: input.name,
                              col: input.col,
                              literal: input.literal,
                              options: input.options,
                              value: input.selectedValue,
                              showTooltipBtn: input.literal_aid.length > 0,
                              textTooltipBtn:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : input.type === "textmap"
                        ? _c("ma-input-textmap", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              type: "textmap",
                              name: input.name,
                              col: input.col,
                              literal: input.literal,
                              value: input.selectedValue,
                              coordinates: _vm.stateWarrantyCoordinates,
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEventTextNumber.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray, ["textNumbers"])
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEventTextNumber.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray, ["textNumbers"])
                                )
                              }
                            }
                          })
                        : input.type === "textmapline"
                        ? _c("ma-input-textmapline", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              type: "textmapline",
                              name: input.name,
                              col: input.col,
                              literal: input.literal,
                              value: input.selectedValue,
                              coordinates: _vm.stateWarrantyCoordinates,
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEventTextNumber.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray, ["textNumbers"])
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEventTextNumber.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray, ["textNumbers"])
                                )
                              }
                            }
                          })
                        : input.type === "imgRadio"
                        ? _c("ma-input-imgradio", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              type: "imgRadio",
                              name: input.name,
                              col: input.col,
                              literal: input.literal,
                              options: input.options,
                              value: input.selectedValue,
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : input.type === "selectmapline"
                        ? _c("ma-input-select-map", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              type: "select",
                              name: input.name,
                              col: input.col,
                              icon: input.icon,
                              literal: input.literal,
                              options: input.options,
                              value: input.selectedValue,
                              coordinates: _vm.stateWarrantyCoordinates,
                              measure: "line",
                              viewer: "",
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : input.type === "selectmap"
                        ? _c("ma-input-select-map", {
                            class: {
                              tooltipVisible: input.literal_aid.length > 0
                            },
                            attrs: {
                              type: "select",
                              name: input.name,
                              col: input.col,
                              icon: input.icon,
                              literal: input.literal,
                              options: input.options,
                              value: input.selectedValue,
                              coordinates: _vm.stateWarrantyCoordinates,
                              measure: "surface",
                              viewer: "",
                              showTooltip: input.literal_aid.length > 0,
                              textTooltip:
                                input.literal_aid.length > 0
                                  ? input.literal_aid
                                  : null,
                              validators: input.validators
                            },
                            on: {
                              change: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "change",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              },
                              input: function($event) {
                                var i = arguments.length,
                                  argsArray = Array(i)
                                while (i--) argsArray[i] = arguments[i]
                                return _vm.handleEvent.apply(
                                  void 0,
                                  [
                                    "input",
                                    input.hasNestedComponents,
                                    input.name
                                  ].concat(argsArray)
                                )
                              }
                            }
                          })
                        : input.type === "iframeUptec"
                        ? _c("ma-iframe-uptec")
                        : _vm._e()
                    ]
                  })
                ]
              })
            ],
            2
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }